import RegistersShow from '../../../../../../components/inspections/registers/show/RegistersShow.vue'

export default {
  name: "RegisterShow",
  components: { RegistersShow }
};
